var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',[_c('div',{attrs:{"slot":"headerContent"},slot:"headerContent"}),_c('div',{attrs:{"slot":"extra"},slot:"extra"}),_c('div',[_c('div',[_vm._v("Welcome")])])])}
var staticRenderFns = []

export { render, staticRenderFns }